<template>
  <div class="main">
    <div class="wrapper-login">
      <img
        src="assets/administrator/LogoYellowAv.svg"
        alt="logo-av"
        class="logo"
      />
      <AdminInput
        v-model:text="email.val"
        :value="email.val"
        :label="'Usuario'"
        :has-error="email.enabled"
        :error="email.errors.length === 0 ? '' : email.errors[0]"
      />
      <AdminInput
        :is-password="true"
        v-model:text="password.val"
        :value="password.val"
        :label="'Contraseña'"
        :has-error="password.enabled"
        :error="password.errors.length === 0 ? '' : password.errors[0]"
      />
      <StandardButton :buttonLabel="'Ingresar'" :is-disabled="successForm" />
    </div>
  </div>
</template>


<script lang="ts">
import { defineComponent } from "vue";
import StandardButton from "@/components/commons/controls/StandardButton.vue";
import AdminInput from "../../../components/commons/controls/AdminInput.vue";
import { loginValidator } from "./validators/loginValidator";

export default defineComponent({
  name: "LoginView",
  components: {
    StandardButton,
    AdminInput,
  },
  setup() {
    const { email, password, successForm, reset } = loginValidator();

    return { email, password, successForm, reset };
  },
});
</script>


<style scoped lang="scss">
@import "src/ux/admin/login/styles/loginStyle";
</style>
